export const getDocumentForm = ({ fundOpportunities: { document } }) =>
  document?.documentForm;
